<div class="app-login"
    *ngIf="ready">
    <kui-card>
        <kui-card-body class="d-flex flex-column">

            <div *ngIf="reloading"
                class="text-center app-login-content">
                {{ 'LOGIN.LOGGING_OUT' | translate }}
            </div>

            <div *ngIf="!reloading">
                <div class="app-login-logo"
                    *ngIf="logoPath">
                    <img [src]="logoPath"
                        (error)="logoPath = null" />
                </div>


                <div *ngIf="!users"
                    class="app-login-form app-login-content">

                    <div *ngIf="errorMessage"
                        class="border-bottom mb-4"
                        [@fadeAnimation]>
                        <kui-alert type="none"
                            class="key-alert-wrapper bordered no-padding mb-3">
                            <kui-icon name="ban"
                                size="lg"></kui-icon>
                            <span>{{errorMessage}}</span>
                        </kui-alert>
                    </div>

                    <div class="border-bottom mb-4 pb-4 text-center"
                        *ngIf="loginMessage"
                        [innerHTML]="loginMessage|MarkdownToHtml">
                    </div>


                    <div class="border-bottom mb-4"
                        *ngIf="authInfo && authInfo.endpoints && authInfo.endpoints.length > 0">

                        <button *ngFor="let endpoint of authInfo.endpoints; let i = index"
                            #button
                            tabindex="4"
                            (click)="activeButton = button; loginWithOpenId(endpoint);"
                            class="w-100 mb-4"
                            [disabled]="loading"
                            kui-button
                            [color]="i === 0 ? 'primary' : 'secondary'">
                            <span *ngIf="activeButton !== button">{{ 'LOGIN.LOGIN_WITH' | translate: { name: endpoint.name } }}</span>
                            <span *ngIf="activeButton === button"
                                class="flex-center-children">
                                <span class="mr-1">{{ 'LOGIN.LOGGING_IN' | translate }}</span>
                                <kui-loader size="small"
                                    [inverse]="true"></kui-loader>
                            </span>
                        </button>

                    </div>

                    <form (submit)="doLogin('password')"
                        [formGroup]="loginForm"
                        name="login">

                        <div class="border-bottom mb-4 pb-1"
                            *ngIf="apiEndpoints && apiEndpoints.length > 1">

                            <div class="form-group">
                                <kui-input-group>
                                    <kui-icon name="globe"
                                        kui-input-group-addon></kui-icon>
                                    <kui-select (change)="apiEndpointSelected($event)"
                                        [options]="apiEndpoints"
                                        id="apiEndpoint"
                                        name="apiEndpoint">
                                    </kui-select>
                                </kui-input-group>
                            </div>

                            <div class="form-group">
                                <kui-input-group>
                                    <kui-icon name="language"
                                        kui-input-group-addon></kui-icon>
                                    <kui-select (change)="languageSelected($event)"
                                        [options]="languages"
                                        id="languages"
                                        name="languages">
                                    </kui-select>
                                </kui-input-group>
                            </div>
                        </div>

                        <div class="form-group"
                            [hidden]="!inputsEnabled"
                            [class.has-danger]="loginForm.controls['username'].dirty && !loginForm.controls['username'].valid">
                            <kui-input-group>
                                <kui-icon name="envelope"
                                    kui-input-group-addon></kui-icon>
                                <input [formControl]="loginForm.controls['username']"
                                    kui-input
                                    id="username"
                                    type="text"
                                    name="username"
                                    autocomplete="username"
                                    tabindex="1"
                                    [placeholder]="'LOGIN.USERNAME' | translate" />
                            </kui-input-group>
                            <div *ngIf="loginForm.controls['username'].dirty && loginForm.controls['username'].errors">
                                <div *ngIf="loginForm.controls['username'].errors.required"
                                    class="form-control-feedback">
                                    {{ 'LOGIN.USERNAME_REQUIRED' | translate }}
                                </div>
                            </div>
                        </div>

                        <div class="form-group"
                            [hidden]="!inputsEnabled"
                            [class.has-danger]="loginForm.controls['password'].dirty && !loginForm.controls['password'].valid">
                            <kui-input-group>
                                <kui-icon name="key"
                                    kui-input-group-addon></kui-icon>
                                <div class="d-flex flex-1 form-control p-0">
                                    <input kui-input
                                        class="no-border"
                                        [formControl]="loginForm.controls['password']"
                                        type="password"
                                        name="password"
                                        tabindex="2"
                                        [placeholder]="'LOGIN.PASSWORD' | translate"
                                        id="password" />
                                    <a routerLink="/forgot"
                                        class="m-1 mr-3">{{ 'LOGIN.FORGOT' | translate }}</a>
                                </div>
                            </kui-input-group>
                            <div *ngIf="loginForm.controls['password'].dirty && loginForm.controls['password'].errors">
                                <div *ngIf="loginForm.controls['password'].errors.required"
                                    class="form-control-feedback">
                                    {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
                                </div>
                            </div>
                        </div>

                        <button tabindex="3"
                            #passwordLoginButton
                            class="w-100 mt-2"
                            [disabled]="loading"
                            kui-button
                            (click)="activeButton = passwordLoginButton; doLogin('password');"
                            [color]="authInfo && authInfo.endpoints && authInfo.endpoints.length > 0 ? 'secondary' : 'primary'">
                            <span *ngIf="activeButton !== passwordLoginButton">{{ 'LOGIN.LOGIN' | translate }}</span>
                            <span *ngIf="activeButton === passwordLoginButton"
                                class="flex-center-children">
                                <span class="mr-1">{{ 'LOGIN.LOGGING_IN' | translate }}</span>
                                <kui-loader size="small"
                                    [inverse]="true"></kui-loader>
                            </span>
                        </button>

                    </form>
                </div>


                <div *ngIf="users"
                    class='app-login-content'>
                    <key-selection type="account"
                        id="dummy"
                        (onSelection)="doUserSelected($event.id)"></key-selection>
                    <button kui-button
                        class="w-100 mt-4"
                        color="secondary"
                        (click)="doUserSelected(null)">
                        <span>{{ 'DIALOG.CANCEL' | translate }}</span>
                    </button>
                </div>


            </div>

        </kui-card-body>
    </kui-card>
</div>